import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Tilt({
  className,
  steepness = 50,
  position = 0,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // Position 0 = left elevated, position 100 = right elevated
  const maxElevation = (steepness / 100) * 120;
  const leftY = 120 - maxElevation * (1 - position / 100);
  const rightY = 120 - maxElevation * (position / 100);

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <polygon points={ `0,${leftY} 1200,${rightY} 1200,120 0,120` } fill={ fill } mask={ mask } />
    </svg>
  );
}

Tilt.propTypes = {
  className: PropTypes.string,
  steepness: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
